module.exports = __webpack_public_path__ + "static/ELBA_Areal_Beschlussvorlage_GR-7a76f18d512c0ee8d9ddf427d856349c.pdf";